export const fadeTimeout = 200;
export const defaultDisablePortal = false;
export const menuItemPositionIdName = 'data-menu-item-position-id';
export const menuListPositionIdName = 'data-menu-list-position-id';
export const menuPopperPositionIdName = 'data-menu-popper-position-id';
